// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"35":"f7882a10","243":"bbebd40c","282":"faf628a9","508":"19d8d373","587":"09cd077e","679":"c1a72ce9","699":"bc02b7e4","832":"ef35054a","957":"798c576f"}[chunkId] + ".js";
};